import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Row, Col, Alert } from "reactstrap"

// import { Alert } from "reactstrap"

// components
import Applications from "pages/Dashboard/applications"

// services
import ApplicationService from "../../services/applications/Application.service"
import Staff from "services/staff/Staff"
import ApplicationFilter from "components/Filter/ApplicationFilter"
import BaseApplicationView from "pages/Application/View/index"

let appService = null
let plasticsUser = null
let staffService = new Staff()

const UploadManualCertificate = props => {
  const [menu, setMenu] = useState(false)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [appDetails, setappDetails] = useState({})
  const [signedCertificate, setsignedCertificate] = useState(null)
  const [disableButton, setdisableButton] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    appService = new ApplicationService(userObj)

    setuser(userObj)
    plasticsUser = appService.getStrategy("officer")
    const appId = props.location.search.split("=")[1]
    appService.getApplicationDetails(appId).then(response => {
      if (response.status) {
        setappDetails(response.data)
        setmounted(true)
      }
    })
  }, [])

  const handleDocumentChange = e => {
    if (e.target.files.length > 0) {
      setsignedCertificate(e.target.files[0])
    }
  }

  async function uploadCertificate(e) {
    e.preventDefault()
    if (signedCertificate == null) {
      alert("Please select signed certificate!")
      return
    }
    setShowSuccessAlert(false)
    setdisableButton(true)

    const certificate = {
      file: signedCertificate,
      application_id: appDetails.id,
      description: "manual_certificate",
    }

    const response = await appService.uploadSignedManualCertificate(certificate)

    if (response.status) {
      setdisableButton(false)
      setShowSuccessAlert(true)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Manual Certificate | Staff</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Manual Certificate Upload</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active">
                    You will upload final manual certificate here.
                  </li>
                </ol>
              </Col>
            </Row>
          </div>

          {mounted ? (
            <Row>
              {/* Show success alert when a message is sent successfully */}
              {showSuccessAlert && (
                <Alert color="success">
                  Signed Certificate uploaded successfully!
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowSuccessAlert(false)}
                  >
                    &times;
                  </button>
                </Alert>
              )}
              <Row className="mb-3">
                <label>Upload Signed Certificate</label>
                <form>
                  <input
                    className="form form-control"
                    type="file"
                    name="final_manual_certificate"
                    accept=".pdf"
                    onChange={handleDocumentChange}
                    required
                  />
                  <br></br>
                  <button
                    onClick={uploadCertificate}
                    disabled={disableButton}
                    className="btn btn-primary"
                    type="submit"
                  >
                    Upload Certificate
                  </button>
                </form>
              </Row>
              <BaseApplicationView appDetails={appDetails} />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default UploadManualCertificate
